import { useEffect } from 'react';

function StructuredData() {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "COVAI HELLO TRUCK PRIVATE LIMITED",
      "image": "https://hellotruck.in/hellotruck-web-images/hello-truck-logo-curved.png",
      "@id": "https://hellotruck.in",
      "url": "https://hellotruck.in",
      "telephone": "+917053315331",
      "priceRange": "Rs.200 onwards",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "No. 7, Kasthuribai Gandhi Nagar 3rd St, Varadharajapuram",
        "addressLocality": "Singanallur, Coimbatore",
        "postalCode": "641015",
        "addressRegion": "Tamil Nadu",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.0168,
        "longitude": 76.9558
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [],
      "areaServed": [
        {
          "@type": "City",
          "name": "Coimbatore"
        },
        {
          "@type": "City",
          "name": "Tiruppur"
        },
        {
          "@type": "State",
          "name": "Tamil Nadu"
        }
      ],
      "description": "Professional truck booking, home shifting & goods transportation services in Coimbatore & Tiruppur. Book Kutty Yaanai (Tata Ace), 407 vehicle, Bolero, load vehicles, mini trucks, tempo, lorry rental starting at Rs.200",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "200"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}

export default StructuredData;
